/* eslint-disable react-hooks/exhaustive-deps */
import Navbar from "../../components/Navbar/Navbar";
import { Fade } from 'react-reveal';
// import img from '../../assets/b8.jpg';
import img from '../../assets/back (6).JPG';
// import { useTranslation } from 'react-i18next';
import { useContext, useEffect, useState } from "react";
import i18n from "../../i18n";
import { GlobalState } from "../../globalState";
import { useSelector } from "react-redux";
import axios from "axios";
import './about.css'
import { appAddress } from "../../App";

export default function About() {
  // const { t } = useTranslation();
  const state = useContext(GlobalState);
  const [getAbouts, setGetAbouts] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [token] = useSelector((state) => state.token);
  const [callback, setCallback] = state.TeamAPI.callback;
  

    useEffect(() => {
      const savedLanguage = localStorage.getItem('language') || 'en';
      i18n.changeLanguage(savedLanguage);
    
      const paragraphElement = document.querySelector('.about-text'); 
      if (paragraphElement) {
        if (savedLanguage === 'fa' || savedLanguage === 'ar') {
          paragraphElement.classList.remove('text-left');
          paragraphElement.classList.add('text-right');
        } else {
          paragraphElement.classList.remove('text-right');
          paragraphElement.classList.add('text-left');
        }
      }
    }, []);

     //about us
  const fetchAbouts = async () => {
    try {
      const res = await axios.get(`${appAddress}/api/about`, {
      // const res = await axios.get(`/api/about`, {
        headers: { Authorization: token },
      });

      console.log("res: ", res)
      setGetAbouts(res.data);
      setCallback(!callback);
    } catch (err) {
      console.log('Fetch Error', err);
    }
  };
    

  const fetchTeamMembers = async () => {
    try {
      const res = await axios.get(`${appAddress}/api/team`, {
      // const res = await axios.get('/api/team', {
        headers: { Authorization: token },
      });
      setTeamMembers(res.data);
      setCallback(!callback); 
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchAbouts();
    fetchTeamMembers();
  }, [callback]);

  return (
    <div className="mb-10 w-[100%] flex flex-col tablet:flex-col justify-center items-center m-auto ">
      <header className="sticky top-0 z-50 flex justify-center items-center w-[100%]">
              <div className="m-auto w-[90%] mt-2 ltr">
                <Navbar />
              </div>
            </header>

        {/* about us */}
      <div className='  mt-14 mb-4  laptop:w-[90%] desktop:w-[80%] desktopXL:w-[80%] flex flex-col laptop:flex-row justify-between items-center'>
        <div className=' w-[90%] m-auto tablet:w-[80%] laptop:w-[48%] desktop:w-[45%] mt-1 mx-2 p-2 '>
          <Fade top>
            <h1 className=' text-3xl text-center uppercase font-englishTitle'>Peidaa<hr className='w-3/6 m-auto text-center text-gray-900'/></h1>
          </Fade>

            {/* about us */}

          {/* <div className="bg-blue-500 m-auto w-[90%]"> */}
          {
            i18n.language === "en" ? (
              <div className="mt-5 text-justify "> 
                {/* <Fade left> */}
                {
                  getAbouts.map(({ _id, desc })=> (
                    <div key={_id}>
                      <p className="font-english text-base/7 ">{desc}</p>
                    </div>
                  ))
                }
                {/* </Fade> */}
              </div>
            ) : i18n.language === "fa" ? (
              <div className="mt-5 text-justify">
                {/* <Fade left> */}
                {
                  getAbouts.map(({ _id, pDesc })=> (
                    <div key={_id}>
                      <p className="font-persian text-base/7 ">{pDesc}</p>
                    </div>
                  ))
                }
                {/* </Fade> */}
              </div>
            ) :  i18n.language === "ar" ? (
              <div className="mt-5 text-justify">
                {/* <Fade left> */}
                {
                  getAbouts.map(({ _id, aDesc })=> (
                    <div key={_id}>
                      <p className="font-persian text-base/7 ">{aDesc}</p>
                    </div>
                  ))
                }
                {/* </Fade> */}
              </div>
            ) : ''
          }
          {/* </div> */}
        </div>

        <div className={`w-full h-4/6 tablet:w-[50%] mt-1 laptop:w-3/6 tablet:h-[450px] desktop:h-[500px] order-first desktopXL:h-[550px] ${i18n.language === 'en' ? '' : 'laptop:order-last'}`}>
            <Fade bottom>
            <img className='desktopXL: w-full p-1 tablet:h-[350px] desktopXLh-[500px] tablet:mt-14 laptop:m-auto laptop:h-full desktop:m-auto' src={img} alt="about" />
          </Fade>
        </div>
      </div>

      <hr className='border-gray-400 w-[95%] desktop:w-[60%] mt-7'/>

      {/* team member */}
      <div className="w-[100%] grid grid-cols-1 mt-14">
  {
    i18n.language === "en" ? (
      <div className="w-[100%] laptop:w-fit h-fit p-3 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 gap-12 m-auto">
        {
          teamMembers.map(({ _id, image, name, position }) => (
            <Fade bottom>
            <div
              key={_id}
              className="relative w-[100%] p-2 border rounded-full grayscale hover:grayscale-0 border-slate-800 flex justify-center"
            >
                <img
                  src={image}
                  alt=""
                  className="w-[100%] tablet:w-[100%] laptop:w-[300px] desktop:w-[270px] object-cover rounded-full" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white transition-opacity duration-300 bg-opacity-75 rounded-full opacity-0 bg-black/40 backdrop-blur-md hover:opacity-100">
                <h3 className="text-2xl cursor-default font-englishTitle about-text">{name}</h3>
                <h4 className="mt-2 text-lg cursor-default font-english about-text">{position}</h4>
              </div>
            </div>
              </Fade>
          ))
        }
      </div>
    ) : i18n.language === "fa" ? (
      <div className="w-[100%] laptop:w-fit h-fit p-3 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 gap-12 m-auto ">
        {
          teamMembers.map(({ _id, image, pName, pPosition }) => (
            <div
              key={_id}
              className="relative w-[100%] p-2 border rounded-full grayscale hover:grayscale-0 border-slate-800 flex justify-center"
            >
              <Fade bottom>
                <img
                  src={image}
                  alt=""
                  className="w-[250px] h-[250px] tablet:w-[280px] tablet:h-[280px] laptop:w-[300px] laptop:h-[300px] desktop:w-[320px] desktop:h-[320px] object-cover rounded-full"
                />
              </Fade>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white transition-opacity duration-300 bg-opacity-75 rounded-full opacity-0 bg-black/40 backdrop-blur-md hover:opacity-100">
                <h3 className="text-2xl cursor-default font-persianTitle about-text">{pName}</h3>
                <h4 className="mt-2 text-lg cursor-default font-persian about-text">{pPosition}</h4>
              </div>
            </div>
          ))
        }
      </div>
    ) : i18n.language === "ar" ? (
      <div className="w-[100%] laptop:w-fit h-fit p-3 grid grid-cols-1 tablet:grid-cols-2 laptop:grid-cols-3 desktop:grid-cols-3 gap-12 m-auto">
        {
          teamMembers.map(({ _id, image, aName, aPosition }) => (
            <div
              key={_id}
              className="relative w-[100%] p-2 border rounded-full grayscale hover:grayscale-0 border-slate-800 flex justify-center"
            >
              <Fade bottom>
                <img
                  src={image}
                  alt=""
                  className="w-[250px] h-[250px] tablet:w-[280px] tablet:h-[280px] laptop:w-[300px] laptop:h-[300px] desktop:w-[320px] desktop:h-[320px] object-cover rounded-full"
                />
              </Fade>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white transition-opacity duration-300 bg-opacity-75 rounded-full opacity-0 bg-black/40 backdrop-blur-md hover:opacity-100">
                <h3 className="text-2xl cursor-default font-persianTitle about-text">{aName}</h3>
                <h4 className="mt-2 text-lg cursor-default font-persian about-text">{aPosition}</h4>
              </div>
            </div>
          ))
        }
      </div>
    ) : ''
  }
</div>
    </div>
  );
}
